import styled from 'styled-components/';
import Dialog from '@mui/material/Dialog';
import AppCSS from '../../utils/styled';
import DialogContent from '@mui/material/DialogContent';
import { MEDIUM_PROJECT_MODAL_WIDTH } from '../../utils/styled/dimensions';

export const Components = {
  Modal: styled(Dialog)<{ modalWidth?: number | 'auto' }>`
    & .MuiDialog-paper {
      ${({ modalWidth }) =>
        modalWidth === 'auto'
          ? 'width: auto;'
          : `
        width: ${modalWidth ? modalWidth : MEDIUM_PROJECT_MODAL_WIDTH}px;
        max-width: ${modalWidth ? modalWidth : MEDIUM_PROJECT_MODAL_WIDTH}px;
      `}
      max-width: calc(100vw - 32px);
      max-height: calc(100vh - 48px);
      overflow-y: auto;
      padding: 20px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      background-color: ${AppCSS.colors.white};
      ${AppCSS.boxShadows.modal};
      ${AppCSS.radiuses.regular};
    }
  `,
  ModalHeader: styled.div<{ noBottomLine: boolean | undefined }>`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding-bottom: 16px;
    border-bottom: ${(props) => (props.noBottomLine ? null : `1px solid ${AppCSS.colors.greys.light}`)}};
  `,
  TitleWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 6px 0;
  `,
  ModalHeaderTitle: styled.span`
    ${AppCSS.fonts.h3};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  TitleSuffix: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.dark};
  `,
  ModalHeaderIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    ${AppCSS.radiuses.default};
    &:hover {
      cursor: pointer;
      background-color: ${AppCSS.colors.blues.veryLight};
    }
    &:focus-visible {
      outline: 2px solid ${AppCSS.colors.blues.primary};
    }
  `,
  ModalButtonsContainer: styled.div`
    width: 100%;
    padding: 16px 0 4px 0;
    gap: 12px;
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  ModalContentContainer: styled(DialogContent)<{ noBottomLine: boolean | undefined }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: 16px;
    margin-bottom: 8px;
    padding: 0 !important;
  `,
};
